import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { usePixKeys } from './usePixKeys';
import { usePixNavigation } from './usePixNavigation';
export function usePixPageControl() {
    const { t } = useTranslation();
    const location = useLocation();
    const { pixKeys } = usePixKeys();
    const [showCreationSuccess, setShowCreationSuccess] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [showCreationError, setShowCreationError] = useState(false);
    const [showValidationError, setShowValidationError] = useState(false);
    const [validationErrorMessage, setValidationErrorMessage] = useState(null);
    const [creationError, setCreationError] = useState(null);
    const { handleBackToList, handleFirstKey, handleCreatePixKey, handlePixCopyPaste, handlePixTransfer, handleNavigateToConfirmation, } = usePixNavigation();
    const isCreationRoute = location.pathname === '/conta-pj/pix/criar';
    const confirmationData = location.state;
    const handleBackToListWithSuccess = useCallback((success) => {
        if (success === false && pixKeys && pixKeys.length >= 5) {
            setValidationError(t('pix-keys.max-keys-error'));
        }
        else if (success === false) {
            setShowCreationError(true);
        }
        else if (success) {
            setShowCreationSuccess(true);
        }
        handleBackToList();
    }, [handleBackToList, pixKeys, t]);
    const handleBackToListWithError = useCallback((error) => {
        console.log('🔴 handleBackToListWithError called with:', error);
        setCreationError(error);
        setShowCreationError(true);
        console.log('🔴 showCreationError set to true');
        handleBackToList();
    }, [handleBackToList]);
    const handleCloseCreationSuccess = useCallback(() => {
        setShowCreationSuccess(false);
    }, []);
    const handleCloseCreationError = useCallback(() => {
        setShowCreationError(false);
        setCreationError(null);
    }, []);
    const handleValidationError = useCallback((error) => {
        setValidationErrorMessage(error);
        setShowValidationError(true);
        handleBackToList();
    }, [handleBackToList]);
    const handleCloseValidationError = useCallback(() => {
        setValidationError(null);
        setShowValidationError(false);
        setValidationErrorMessage(null);
    }, []);
    return {
        showCreationSuccess,
        showCreationError,
        validationError,
        creationError,
        showValidationError,
        validationErrorMessage,
        isCreationRoute,
        confirmationData,
        handleBackToListWithSuccess,
        handleBackToListWithError,
        handleCloseCreationSuccess,
        handleCloseCreationError,
        handleValidationError,
        handleCloseValidationError,
        handleFirstKey,
        handleCreatePixKey,
        handlePixCopyPaste,
        handlePixTransfer,
        handleNavigateToConfirmation,
    };
}
